import { useLang } from "@/contexts/LanguageContext";

export default function Location() {
  const { t } = useLang();
  return (
    <section id="ubicacion" data-testid="location-section" className="bg-[#FAFAF9] py-24 md:py-40">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <p className="text-eyebrow text-[#E07A5F] mb-4">{t("location.eyebrow")}</p>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-stone-900 mb-8">
            {t("location.title")}
          </h2>
          <div className="space-y-4 text-stone-700 text-lg leading-relaxed">
            <p>{t("location.p1")}</p>
            <p>{t("location.p2")}</p>
          </div>
          <div className="mt-8 border-l-2 border-[#E07A5F] bg-stone-100 p-6">
            <div className="text-eyebrow text-[#E07A5F] mb-2">{t("location.tip_title")}</div>
            <p className="text-sm text-stone-700 leading-relaxed">{t("location.tip")}</p>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-4">
            {[
              { n: "3.5h", l: "Desde CDMX" },
              { n: "15min", l: "Por la playa" },
              { n: "0m", l: "Del mar" },
            ].map((s, i) => (
              <div key={i} className="border-t border-stone-300 pt-3">
                <div className="font-serif-display text-3xl md:text-4xl text-stone-900">{s.n}</div>
                <div className="text-xs text-stone-500 uppercase tracking-wider mt-1">{s.l}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="aspect-[4/3] w-full overflow-hidden border border-stone-200 bg-stone-200">
            <iframe
              title="Mapa — La Casita · Villas Pura Vida en Playa Norte, Barra de Galindo, Tuxpan"
              data-testid="location-map"
              src="https://www.google.com/maps?q=La+Casita+Villas+Pura+Vida+Playa+Norte+Barra+de+Galindo+Tuxpan+Veracruz&ll=21.0791581,-97.3714559&z=15&output=embed"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full h-full border-0"
            />
          </div>
          <div className="mt-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3 text-sm">
            <div className="text-stone-700 leading-relaxed">
              <p className="font-semibold text-stone-900">Playa Norte, 92773 Barra de Galindo, Veracruz</p>
              <p className="text-xs uppercase tracking-wider text-stone-500 mt-1">
                Plus Code: 3JMQ+8Q Laja, Veracruz · 21.0791, -97.3714
              </p>
            </div>
            <a
              data-testid="location-maps-link"
              href="https://www.google.com/maps/place/La+Casita+%E2%80%A2+Villas+Pura+Vida/@21.0791581,-97.3714559,16z"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 text-[#E07A5F] hover:text-stone-900 transition-colors text-xs uppercase tracking-[0.22em] font-semibold"
            >
              <i className="fa-solid fa-location-dot" />
              Abrir en Google Maps
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
